import Connector, { takeQuery } from '../../agent';
import types from './types';

const Suppliers = {
  getSupplierList: () => Connector.api.get('/suppliers/autocomplete')
};

const supplierSagas = [takeQuery(types.GET_SUPPLIER_LIST, Suppliers.getSupplierList)];

export default supplierSagas;
